'use client';

import { useCustomerly } from 'react-live-chat-customerly';
import { useEffect } from 'react';

const CustomerlyLoader = () => {
  const { load } = useCustomerly();

  useEffect(() => {
    load({
      accentColor: '#003366',
      contrastColor: '#FFFFFF',
    });
  }, [load]);

  return <></>;
};

export default CustomerlyLoader;
